const HISTORY_COLUMNS_DATA = [
  { key: "property_history", message: "houseDetails.propertyHistory.priceAndSaleHistory", span: 12 },
  { key: "tax_history", message: "houseDetails.taxHistory.publicTaxHistory", span: 8 },
];

export { HISTORY_COLUMNS_DATA };
